// extracted by mini-css-extract-plugin
export default {"iconMarker":"styles_iconMarker__Qgo4E","iconTransport":"styles_iconTransport__AkS29","iconText":"styles_iconText__3wZEK"};